import { fetchDataV2 } from "./utils";

export const getTags = () => fetchDataV2("/annotation/tag/get-all-tags");
